<div class="user-detail-view-container">
  <div class="header">
    <ng-container>
      <span *ngIf="!user?.id">New Driver</span>
      <span *ngIf="user?.id">Edit Driver</span>
    </ng-container>
    <i class="material-icons" (click)="closeClicked()">close</i>
  </div>
  <div class="detail-content">
    <div class="content-header">Driver Info</div>
    <form [formGroup]="formGroup">
      <mat-form-field style="width: 100%;">
        <input matInput formControlName="name" placeholder="Name" autocomplete="off" (blur)="updateDriver()" />
      </mat-form-field>
      <div class="phone-input" style="margin: 0 0 16px 0;">
        <ngx-mat-intl-tel-input
          [preferredCountries]="['us', 'ar']"
          [enablePlaceholder]="true"
          [enableSearch]="true"
          name="phone"
          formControlName="phone"
          (blur)="updateDriver()"
        ></ngx-mat-intl-tel-input>
      </div>
      <mat-form-field style="width: 100%;">
        <input matInput formControlName="pin" placeholder="Pin" autocomplete="off" (blur)="updateDriver()" />
      </mat-form-field>
      <mat-form-field style="width: 100%;">
        <input matInput formControlName="cdl" placeholder="CDL" autocomplete="off" (blur)="updateDriver()" />
      </mat-form-field>
    </form>

    <ng-container *ngIf="user?.id">
      <div class="content-header">Danger Zone</div>
      <div class="danger-zone">
        Removing this driver will delete any scheduled or in-progress tasks assigned to this driver, and prevent them
        from receiving new tasks. This cannot be undone.
      </div>

      <button type="button" sa-danger-button (click)="removeDriver(user?.id)">
        Remove Driver
      </button>
    </ng-container>

    <ng-container *ngIf="!user?.id">
      <button type="button" [disabled]="buttonDisabled || formGroup.invalid" sa-button (click)="inviteDriver()">
        Invite Driver
      </button>
    </ng-container>
  </div>
</div>
